module.exports = __webpack_public_path__ + "static/img/fengsheng.78143c2.png";


//////////////////
// WEBPACK FOOTER
// ./static/fengsheng.png
// module id = SDeU
// module chunks = 1